import { render, staticRenderFns } from "./LandingPagesNewOrEdit.vue?vue&type=template&id=732cb112&"
import script from "./LandingPagesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LandingPagesNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports